import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PagedResponse } from '../core';
import {
  ListSubscriptionRetentionByGroupResponse,
  ListSubscriptionRetentionBySKUResponse,
  ListSubscriptionRetentionRequest,
  ProductSummaryApiService,
  PagedRequestOptions,
} from '@vendasta/billing';
import {
  ListSubscriptionRetentionFilters,
  subscriptionMetricFromAPI,
  subscriptionMetricByGroupFromAPI,
  RetentionMetrics,
  RetentionMetricsByGroup,
} from './subscription-retention';

@Injectable({ providedIn: 'root' })
export class ProductSummaryService {
  constructor(private productSummaryApi: ProductSummaryApiService) {}

  listSubscriptionRetentionBySKU(
    merchantID: string,
    filters: ListSubscriptionRetentionFilters,
    cursor: string,
    pageSize: number,
  ): Observable<PagedResponse<RetentionMetrics>> {
    const req = new ListSubscriptionRetentionRequest({
      merchantId: merchantID,
      filters,
      pagingOptions: new PagedRequestOptions({ cursor, pageSize }),
    });
    return this.productSummaryApi.listSubscriptionRetentionBySku(req).pipe(
      map((response: ListSubscriptionRetentionBySKUResponse) => {
        const metrics = (response.subscriptionMetrics || []).map((metric) => subscriptionMetricFromAPI(metric));
        return new PagedResponse(metrics, response.pagingMetadata.nextCursor, response.pagingMetadata.hasMore);
      }),
    );
  }

  listSubscriptionRetentionByGroup(
    merchantID: string,
    filters: ListSubscriptionRetentionFilters,
    cursor: string,
    pageSize: number,
  ): Observable<PagedResponse<RetentionMetricsByGroup>> {
    const req = new ListSubscriptionRetentionRequest({
      merchantId: merchantID,
      filters,
      pagingOptions: new PagedRequestOptions({ cursor, pageSize }),
    });
    return this.productSummaryApi.listSubscriptionRetentionByGroup(req).pipe(
      map((response: ListSubscriptionRetentionByGroupResponse) => {
        const metricsByGroup = (response.metricsByGroup || []).map((m) => subscriptionMetricByGroupFromAPI(m));
        return new PagedResponse(metricsByGroup, response.pagingMetadata.nextCursor, response.pagingMetadata.hasMore);
      }),
    );
  }
}
